import React from 'react';

const TheadTableConciliaciones = () => {
  return (
    <thead className="sticky top-0 z-10 bg-gray-100 text-sm uppercase text-gray-700 ">
      <tr>
        <th className="w-12 whitespace-nowrap px-2 py-2 text-left text-xs font-semibold uppercase">ID</th>
        <th className="w-28 whitespace-nowrap px-2 py-2 text-left text-xs font-semibold uppercase">Token</th>
        <th className="w-24 whitespace-nowrap px-2 py-2 text-left text-xs font-semibold uppercase">Estado</th>
        <th className="w-72 whitespace-nowrap px-2 py-2 text-left text-xs font-semibold uppercase">Archivo</th>
        <th className="w-40 whitespace-nowrap px-2 py-2 text-left text-xs font-semibold uppercase">Hoja</th>
        <th className="w-24 whitespace-nowrap px-2 py-2 text-right text-xs font-semibold uppercase">Total filas</th>
        <th className="w-20 whitespace-nowrap px-2 py-2 text-left text-xs font-semibold uppercase">Usuario</th>
        <th className="w-36 whitespace-nowrap px-2 py-2 text-left text-xs font-semibold uppercase">Fecha</th>
        <th className="w-36 whitespace-nowrap px-2 py-2 text-left text-xs font-semibold uppercase">Actualizado</th>
        <th className="w-20 whitespace-nowrap px-2 py-2 text-right text-xs font-semibold uppercase">Val/Err</th>
        <th
          scope="col"
          className="w-2 px-1 py-2"></th>

        <th
          scope="col"
          className="w-2 px-1 py-2"></th>
      </tr>
    </thead>
  );
};

export default TheadTableConciliaciones;
